"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bucket Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalApi = exports.InternalApiFactory = exports.InternalApiFp = exports.InternalApiAxiosParamCreator = exports.GroupInclusionsApi = exports.GroupInclusionsApiFactory = exports.GroupInclusionsApiFp = exports.GroupInclusionsApiAxiosParamCreator = exports.FilesApi = exports.FilesApiFactory = exports.FilesApiFp = exports.FilesApiAxiosParamCreator = exports.BucketsApi = exports.BucketsApiFactory = exports.BucketsApiFp = exports.BucketsApiAxiosParamCreator = exports.AttachmentsApi = exports.AttachmentsApiFactory = exports.AttachmentsApiFp = exports.AttachmentsApiAxiosParamCreator = exports.BucketServiceFileItemTypeDto = exports.BucketServiceFileBreadcrumbDtoTypeEnum = exports.BucketServiceBucketTargetDto = exports.BucketServiceAttachmentKindDto = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.BucketServiceAttachmentKindDto = {
    File: 'file',
    Image: 'image',
    Video: 'video',
    Audio: 'audio',
    Doc: 'doc',
    Archive: 'archive',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BucketServiceBucketTargetDto = {
    Task: 'task',
    Comment: 'comment',
    Note: 'note',
    PortalPage: 'portalPage',
    PortalGlobal: 'portalGlobal',
    PortalFiles: 'portalFiles',
    PortalBlock: 'portalBlock',
};
exports.BucketServiceFileBreadcrumbDtoTypeEnum = {
    Portal: 'portal',
    PortalPage: 'portalPage',
    PortalGlobal: 'portalGlobal',
    PortalFiles: 'portalFiles',
    Note: 'note',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BucketServiceFileItemTypeDto = {
    Image: 'image',
    Video: 'video',
    Audio: 'audio',
    Doc: 'doc',
    Archive: 'archive',
    File: 'file',
};
/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
const AttachmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete attachment
         * @param {string} globalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteAttachment: async (globalId, options = {}) => {
            // verify required parameter 'globalId' is not null or undefined
            (0, common_1.assertParamExists)('apiDeleteAttachment', 'globalId', globalId);
            const localVarPath = `/attachments/{globalId}`.replace(`{${'globalId'}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create attachment from tempFileName
         * @param {string} globalId
         * @param {string} workspaceId
         * @param {BucketServiceCreateAttachmentDataDto} [tempFileName] Attachment data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPutAttachment: async (globalId, workspaceId, tempFileName, options = {}) => {
            // verify required parameter 'globalId' is not null or undefined
            (0, common_1.assertParamExists)('apiPutAttachment', 'globalId', globalId);
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('apiPutAttachment', 'workspaceId', workspaceId);
            const localVarPath = `/attachments/{globalId}`.replace(`{${'globalId'}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tempFileName, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update attachment
         * @param {string} globalId
         * @param {BucketServiceUpdateAttachmentDataDto} [body] Attachment update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAttachment: async (globalId, body, options = {}) => {
            // verify required parameter 'globalId' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAttachment', 'globalId', globalId);
            const localVarPath = `/attachments/{globalId}`.replace(`{${'globalId'}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AttachmentsApiAxiosParamCreator = AttachmentsApiAxiosParamCreator;
/**
 * AttachmentsApi - functional programming interface
 * @export
 */
const AttachmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AttachmentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete attachment
         * @param {string} globalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeleteAttachment(globalId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeleteAttachment(globalId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Create attachment from tempFileName
         * @param {string} globalId
         * @param {string} workspaceId
         * @param {BucketServiceCreateAttachmentDataDto} [tempFileName] Attachment data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPutAttachment(globalId, workspaceId, tempFileName, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPutAttachment(globalId, workspaceId, tempFileName, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update attachment
         * @param {string} globalId
         * @param {BucketServiceUpdateAttachmentDataDto} [body] Attachment update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateAttachment(globalId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateAttachment(globalId, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AttachmentsApiFp = AttachmentsApiFp;
/**
 * AttachmentsApi - factory interface
 * @export
 */
const AttachmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AttachmentsApiFp)(configuration);
    return {
        /**
         * Delete attachment
         * @param {AttachmentsApiApiDeleteAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteAttachment(requestParameters, options) {
            return localVarFp
                .apiDeleteAttachment(requestParameters.globalId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create attachment from tempFileName
         * @param {AttachmentsApiApiPutAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPutAttachment(requestParameters, options) {
            return localVarFp
                .apiPutAttachment(requestParameters.globalId, requestParameters.workspaceId, requestParameters.tempFileName, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update attachment
         * @param {AttachmentsApiApiUpdateAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAttachment(requestParameters, options) {
            return localVarFp
                .apiUpdateAttachment(requestParameters.globalId, requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AttachmentsApiFactory = AttachmentsApiFactory;
/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
class AttachmentsApi extends base_1.BaseAPI {
    /**
     * Delete attachment
     * @param {AttachmentsApiApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    apiDeleteAttachment(requestParameters, options) {
        return (0, exports.AttachmentsApiFp)(this.configuration)
            .apiDeleteAttachment(requestParameters.globalId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create attachment from tempFileName
     * @param {AttachmentsApiApiPutAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    apiPutAttachment(requestParameters, options) {
        return (0, exports.AttachmentsApiFp)(this.configuration)
            .apiPutAttachment(requestParameters.globalId, requestParameters.workspaceId, requestParameters.tempFileName, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update attachment
     * @param {AttachmentsApiApiUpdateAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    apiUpdateAttachment(requestParameters, options) {
        return (0, exports.AttachmentsApiFp)(this.configuration)
            .apiUpdateAttachment(requestParameters.globalId, requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AttachmentsApi = AttachmentsApi;
/**
 * BucketsApi - axios parameter creator
 * @export
 */
const BucketsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copy buckets
         * @param {string} workspaceId
         * @param {BucketServiceApiCopyBucketsRequestDto} [data] Bucket data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCopyBuckets: async (workspaceId, data, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('apiCopyBuckets', 'workspaceId', workspaceId);
            const localVarPath = `/buckets/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a bucket
         * @param {string} workspaceId
         * @param {BucketServiceBucketTargetDataDto} [data] Bucket data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateBucket: async (workspaceId, data, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('apiCreateBucket', 'workspaceId', workspaceId);
            const localVarPath = `/buckets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get buckets
         * @param {string} workspaceId
         * @param {string} [groupId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetBuckets: async (workspaceId, groupId, target, targetId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('apiGetBuckets', 'workspaceId', workspaceId);
            const localVarPath = `/buckets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }
            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BucketsApiAxiosParamCreator = BucketsApiAxiosParamCreator;
/**
 * BucketsApi - functional programming interface
 * @export
 */
const BucketsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BucketsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Copy buckets
         * @param {string} workspaceId
         * @param {BucketServiceApiCopyBucketsRequestDto} [data] Bucket data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCopyBuckets(workspaceId, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCopyBuckets(workspaceId, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Create a bucket
         * @param {string} workspaceId
         * @param {BucketServiceBucketTargetDataDto} [data] Bucket data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCreateBucket(workspaceId, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCreateBucket(workspaceId, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get buckets
         * @param {string} workspaceId
         * @param {string} [groupId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetBuckets(workspaceId, groupId, target, targetId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetBuckets(workspaceId, groupId, target, targetId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.BucketsApiFp = BucketsApiFp;
/**
 * BucketsApi - factory interface
 * @export
 */
const BucketsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BucketsApiFp)(configuration);
    return {
        /**
         * Copy buckets
         * @param {BucketsApiApiCopyBucketsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCopyBuckets(requestParameters, options) {
            return localVarFp
                .apiCopyBuckets(requestParameters.workspaceId, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Create a bucket
         * @param {BucketsApiApiCreateBucketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateBucket(requestParameters, options) {
            return localVarFp
                .apiCreateBucket(requestParameters.workspaceId, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get buckets
         * @param {BucketsApiApiGetBucketsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetBuckets(requestParameters, options) {
            return localVarFp
                .apiGetBuckets(requestParameters.workspaceId, requestParameters.groupId, requestParameters.target, requestParameters.targetId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.BucketsApiFactory = BucketsApiFactory;
/**
 * BucketsApi - object-oriented interface
 * @export
 * @class BucketsApi
 * @extends {BaseAPI}
 */
class BucketsApi extends base_1.BaseAPI {
    /**
     * Copy buckets
     * @param {BucketsApiApiCopyBucketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BucketsApi
     */
    apiCopyBuckets(requestParameters, options) {
        return (0, exports.BucketsApiFp)(this.configuration)
            .apiCopyBuckets(requestParameters.workspaceId, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a bucket
     * @param {BucketsApiApiCreateBucketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BucketsApi
     */
    apiCreateBucket(requestParameters, options) {
        return (0, exports.BucketsApiFp)(this.configuration)
            .apiCreateBucket(requestParameters.workspaceId, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get buckets
     * @param {BucketsApiApiGetBucketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BucketsApi
     */
    apiGetBuckets(requestParameters, options) {
        return (0, exports.BucketsApiFp)(this.configuration)
            .apiGetBuckets(requestParameters.workspaceId, requestParameters.groupId, requestParameters.target, requestParameters.targetId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.BucketsApi = BucketsApi;
/**
 * FilesApi - axios parameter creator
 * @export
 */
const FilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Search files
         * @param {boolean} [resetCache]
         * @param {string} [orgId]
         * @param {string} [workspaceId]
         * @param {string} [portalId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {Array<string>} [targetIds]
         * @param {Array<string>} [bucketIds]
         * @param {Array<string>} [attachmentIds]
         * @param {number} [limitSize]
         * @param {number} [limitFrom]
         * @param {string} [sortField]
         * @param {string} [sortOrder]
         * @param {string} [permissionsMode]
         * @param {number} [userId]
         * @param {Array<string>} [targets]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetFiles: async (resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options = {}) => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (resetCache !== undefined) {
                localVarQueryParameter['resetCache'] = resetCache;
            }
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }
            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            if (targetIds) {
                localVarQueryParameter['targetIds'] = targetIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (bucketIds) {
                localVarQueryParameter['bucketIds'] = bucketIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (attachmentIds) {
                localVarQueryParameter['attachmentIds'] = attachmentIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (limitSize !== undefined) {
                localVarQueryParameter['limitSize'] = limitSize;
            }
            if (limitFrom !== undefined) {
                localVarQueryParameter['limitFrom'] = limitFrom;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (permissionsMode !== undefined) {
                localVarQueryParameter['permissionsMode'] = permissionsMode;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (targets) {
                localVarQueryParameter['targets'] = targets.join(base_1.COLLECTION_FORMATS.csv);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search files
         * @param {boolean} [resetCache]
         * @param {string} [orgId]
         * @param {string} [workspaceId]
         * @param {string} [portalId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {Array<string>} [targetIds]
         * @param {Array<string>} [bucketIds]
         * @param {Array<string>} [attachmentIds]
         * @param {number} [limitSize]
         * @param {number} [limitFrom]
         * @param {string} [sortField]
         * @param {string} [sortOrder]
         * @param {string} [permissionsMode]
         * @param {number} [userId]
         * @param {Array<string>} [targets]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetFilesCount: async (resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options = {}) => {
            const localVarPath = `/files/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (resetCache !== undefined) {
                localVarQueryParameter['resetCache'] = resetCache;
            }
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }
            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            if (targetIds) {
                localVarQueryParameter['targetIds'] = targetIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (bucketIds) {
                localVarQueryParameter['bucketIds'] = bucketIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (attachmentIds) {
                localVarQueryParameter['attachmentIds'] = attachmentIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (limitSize !== undefined) {
                localVarQueryParameter['limitSize'] = limitSize;
            }
            if (limitFrom !== undefined) {
                localVarQueryParameter['limitFrom'] = limitFrom;
            }
            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (permissionsMode !== undefined) {
                localVarQueryParameter['permissionsMode'] = permissionsMode;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (targets) {
                localVarQueryParameter['targets'] = targets.join(base_1.COLLECTION_FORMATS.csv);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FilesApiAxiosParamCreator = FilesApiAxiosParamCreator;
/**
 * FilesApi - functional programming interface
 * @export
 */
const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FilesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Search files
         * @param {boolean} [resetCache]
         * @param {string} [orgId]
         * @param {string} [workspaceId]
         * @param {string} [portalId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {Array<string>} [targetIds]
         * @param {Array<string>} [bucketIds]
         * @param {Array<string>} [attachmentIds]
         * @param {number} [limitSize]
         * @param {number} [limitFrom]
         * @param {string} [sortField]
         * @param {string} [sortOrder]
         * @param {string} [permissionsMode]
         * @param {number} [userId]
         * @param {Array<string>} [targets]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetFiles(resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetFiles(resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Search files
         * @param {boolean} [resetCache]
         * @param {string} [orgId]
         * @param {string} [workspaceId]
         * @param {string} [portalId]
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {Array<string>} [targetIds]
         * @param {Array<string>} [bucketIds]
         * @param {Array<string>} [attachmentIds]
         * @param {number} [limitSize]
         * @param {number} [limitFrom]
         * @param {string} [sortField]
         * @param {string} [sortOrder]
         * @param {string} [permissionsMode]
         * @param {number} [userId]
         * @param {Array<string>} [targets]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetFilesCount(resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetFilesCount(resetCache, orgId, workspaceId, portalId, target, targetId, targetIds, bucketIds, attachmentIds, limitSize, limitFrom, sortField, sortOrder, permissionsMode, userId, targets, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.FilesApiFp = FilesApiFp;
/**
 * FilesApi - factory interface
 * @export
 */
const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FilesApiFp)(configuration);
    return {
        /**
         * Search files
         * @param {FilesApiApiGetFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetFiles(requestParameters = {}, options) {
            return localVarFp
                .apiGetFiles(requestParameters.resetCache, requestParameters.orgId, requestParameters.workspaceId, requestParameters.portalId, requestParameters.target, requestParameters.targetId, requestParameters.targetIds, requestParameters.bucketIds, requestParameters.attachmentIds, requestParameters.limitSize, requestParameters.limitFrom, requestParameters.sortField, requestParameters.sortOrder, requestParameters.permissionsMode, requestParameters.userId, requestParameters.targets, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Search files
         * @param {FilesApiApiGetFilesCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetFilesCount(requestParameters = {}, options) {
            return localVarFp
                .apiGetFilesCount(requestParameters.resetCache, requestParameters.orgId, requestParameters.workspaceId, requestParameters.portalId, requestParameters.target, requestParameters.targetId, requestParameters.targetIds, requestParameters.bucketIds, requestParameters.attachmentIds, requestParameters.limitSize, requestParameters.limitFrom, requestParameters.sortField, requestParameters.sortOrder, requestParameters.permissionsMode, requestParameters.userId, requestParameters.targets, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.FilesApiFactory = FilesApiFactory;
/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
class FilesApi extends base_1.BaseAPI {
    /**
     * Search files
     * @param {FilesApiApiGetFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    apiGetFiles(requestParameters = {}, options) {
        return (0, exports.FilesApiFp)(this.configuration)
            .apiGetFiles(requestParameters.resetCache, requestParameters.orgId, requestParameters.workspaceId, requestParameters.portalId, requestParameters.target, requestParameters.targetId, requestParameters.targetIds, requestParameters.bucketIds, requestParameters.attachmentIds, requestParameters.limitSize, requestParameters.limitFrom, requestParameters.sortField, requestParameters.sortOrder, requestParameters.permissionsMode, requestParameters.userId, requestParameters.targets, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search files
     * @param {FilesApiApiGetFilesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    apiGetFilesCount(requestParameters = {}, options) {
        return (0, exports.FilesApiFp)(this.configuration)
            .apiGetFilesCount(requestParameters.resetCache, requestParameters.orgId, requestParameters.workspaceId, requestParameters.portalId, requestParameters.target, requestParameters.targetId, requestParameters.targetIds, requestParameters.bucketIds, requestParameters.attachmentIds, requestParameters.limitSize, requestParameters.limitFrom, requestParameters.sortField, requestParameters.sortOrder, requestParameters.permissionsMode, requestParameters.userId, requestParameters.targets, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.FilesApi = FilesApi;
/**
 * GroupInclusionsApi - axios parameter creator
 * @export
 */
const GroupInclusionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get group inclusions
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {string} [bucketId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetGroupInclusions: async (target, targetId, bucketId, options = {}) => {
            const localVarPath = `/groupInclusions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }
            if (bucketId !== undefined) {
                localVarQueryParameter['bucketId'] = bucketId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.GroupInclusionsApiAxiosParamCreator = GroupInclusionsApiAxiosParamCreator;
/**
 * GroupInclusionsApi - functional programming interface
 * @export
 */
const GroupInclusionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GroupInclusionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get group inclusions
         * @param {string} [target]
         * @param {string} [targetId]
         * @param {string} [bucketId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetGroupInclusions(target, targetId, bucketId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetGroupInclusions(target, targetId, bucketId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.GroupInclusionsApiFp = GroupInclusionsApiFp;
/**
 * GroupInclusionsApi - factory interface
 * @export
 */
const GroupInclusionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GroupInclusionsApiFp)(configuration);
    return {
        /**
         * Get group inclusions
         * @param {GroupInclusionsApiApiGetGroupInclusionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetGroupInclusions(requestParameters = {}, options) {
            return localVarFp
                .apiGetGroupInclusions(requestParameters.target, requestParameters.targetId, requestParameters.bucketId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.GroupInclusionsApiFactory = GroupInclusionsApiFactory;
/**
 * GroupInclusionsApi - object-oriented interface
 * @export
 * @class GroupInclusionsApi
 * @extends {BaseAPI}
 */
class GroupInclusionsApi extends base_1.BaseAPI {
    /**
     * Get group inclusions
     * @param {GroupInclusionsApiApiGetGroupInclusionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupInclusionsApi
     */
    apiGetGroupInclusions(requestParameters = {}, options) {
        return (0, exports.GroupInclusionsApiFp)(this.configuration)
            .apiGetGroupInclusions(requestParameters.target, requestParameters.targetId, requestParameters.bucketId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.GroupInclusionsApi = GroupInclusionsApi;
/**
 * InternalApi - axios parameter creator
 * @export
 */
const InternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeletePortalPageBuckets: async (options = {}) => {
            const localVarPath = `/internal/delete-portal-page-buckets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [force]
         * @param {Array<string>} [bucketIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFixPaths: async (force, bucketIds, options = {}) => {
            const localVarPath = `/internal/fix-paths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            if (bucketIds) {
                localVarQueryParameter['bucketIds'] = bucketIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [force]
         * @param {Array<string>} [workspaceIds]
         * @param {Array<string>} [noteIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportNoteAttachments: async (force, workspaceIds, noteIds, options = {}) => {
            const localVarPath = `/internal/import-note-attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            if (workspaceIds) {
                localVarQueryParameter['workspaceIds'] = workspaceIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            if (noteIds) {
                localVarQueryParameter['noteIds'] = noteIds.join(base_1.COLLECTION_FORMATS.csv);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} workspaceId
         * @param {string} [orgId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInitPermissions: async (workspaceId, orgId, options = {}) => {
            // verify required parameter 'workspaceId' is not null or undefined
            (0, common_1.assertParamExists)('apiInitPermissions', 'workspaceId', workspaceId);
            const localVarPath = `/internal/init-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InternalApiAxiosParamCreator = InternalApiAxiosParamCreator;
/**
 * InternalApi - functional programming interface
 * @export
 */
const InternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InternalApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeletePortalPageBuckets(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeletePortalPageBuckets(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {boolean} [force]
         * @param {Array<string>} [bucketIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFixPaths(force, bucketIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFixPaths(force, bucketIds, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {boolean} [force]
         * @param {Array<string>} [workspaceIds]
         * @param {Array<string>} [noteIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportNoteAttachments(force, workspaceIds, noteIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportNoteAttachments(force, workspaceIds, noteIds, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} workspaceId
         * @param {string} [orgId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInitPermissions(workspaceId, orgId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInitPermissions(workspaceId, orgId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.InternalApiFp = InternalApiFp;
/**
 * InternalApi - factory interface
 * @export
 */
const InternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InternalApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeletePortalPageBuckets(options) {
            return localVarFp
                .apiDeletePortalPageBuckets(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InternalApiApiFixPathsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFixPaths(requestParameters = {}, options) {
            return localVarFp
                .apiFixPaths(requestParameters.force, requestParameters.bucketIds, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InternalApiApiImportNoteAttachmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportNoteAttachments(requestParameters = {}, options) {
            return localVarFp
                .apiImportNoteAttachments(requestParameters.force, requestParameters.workspaceIds, requestParameters.noteIds, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InternalApiApiInitPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInitPermissions(requestParameters, options) {
            return localVarFp
                .apiInitPermissions(requestParameters.workspaceId, requestParameters.orgId, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.InternalApiFactory = InternalApiFactory;
/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
class InternalApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    apiDeletePortalPageBuckets(options) {
        return (0, exports.InternalApiFp)(this.configuration)
            .apiDeletePortalPageBuckets(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InternalApiApiFixPathsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    apiFixPaths(requestParameters = {}, options) {
        return (0, exports.InternalApiFp)(this.configuration)
            .apiFixPaths(requestParameters.force, requestParameters.bucketIds, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InternalApiApiImportNoteAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    apiImportNoteAttachments(requestParameters = {}, options) {
        return (0, exports.InternalApiFp)(this.configuration)
            .apiImportNoteAttachments(requestParameters.force, requestParameters.workspaceIds, requestParameters.noteIds, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InternalApiApiInitPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    apiInitPermissions(requestParameters, options) {
        return (0, exports.InternalApiFp)(this.configuration)
            .apiInitPermissions(requestParameters.workspaceId, requestParameters.orgId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.InternalApi = InternalApi;
//# sourceMappingURL=api.js.map